const courseRoutes = {
    Payment: "/courses/payment",
    AllCourses: '/all-courses',
    DuePayment: '/trainee/due-payments',
    ViewPath: "/courses/:course_id",
    ViewLink: (course_id: string) => `/courses/${course_id}`,
    mycourses: '/trainee/courses',
    mycourse:'/trainee/mycourse/:course_id',
    advertisedCourses: '/trainee/advertisedCourses',
    mycourselink: (course_id: string) => `/trainee/mycourse/${course_id}`,
    CourseInformation: '/trainee/course/:course_id/course-information',
    CourseInformationLink: (course_id: string) => `/trainee/course/${course_id}/course-information`,
    Announcement: '/trainee/course/:course_id/announcement',
    AnnouncementLink: (course_id: string) => `/trainee/course/${course_id}/announcement`,
    Lectures: '/trainee/course/:course_id/lectures',
    LecturesLink: (course_id: string) => `/trainee/course/${course_id}/lectures`,
    Calender: '/trainee/course/:course_id/calendar',
    CalenderLink: (course_id: string) => `/trainee/course/${course_id}/calendar`,
    Discussions: '/trainee/course/:course_id/discussions',
    DiscussionsLink: (course_id: string) => `/trainee/course/${course_id}/discussions`,
    Assignments: '/trainee/course/:course_id/assignments',
    AssignmentsLink: (course_id: string) => `/trainee/course/${course_id}/assignments`,
    AssignmentQuiz: '/trainee/course/:course_id/assignments/quiz-answer',
    AssignmentQuizLink: (course_id: string) => `/trainee/course/${course_id}/assignments/quiz-answer`,
    AssignmentTheory: '/trainee/course/:course_id/assignments/theory-answer',
    AssignmentTheoryLink: (course_id: string) => `/trainee/course/${course_id}/assignments/theory-answer`,
    AssignmentInfo: '/trainee/course/:course_id/assignments/info',
    AssignmentInfoLink: (course_id: string) => `/trainee/course/${course_id}/assignments/info`,
    Resources: '/trainee/course/:course_id/resources',
    ResourcesLink: (course_id: string) => `/trainee/course/${course_id}/resources`,
    EachDiscussion: '/trainee/course/:course_id/discussion/:id',
    EachDiscussionLink: (course_id: string, discussion_id:string) => `/trainee/course/${course_id}/discussion/${discussion_id}`,
    NewDiscussion: '/trainee/course/:course_id/discussion/:discussion_id/new-discussion',
    NewDiscussionLink: (course_id: string, discussion_id: string) => `/trainee/course/${course_id}/discussion/${discussion_id}/new-discussion`,
    NewDiscussionGroup: '/trainee/course/:course_id/discussion/new-discussion-group',
    NewDiscussionGroupLink: (course_id: string) => `/trainee/course/${course_id}/discussion/new-discussion-group`,
    EachAnnouncement: '/trainee/course/:course_id/announcement/:id',
    EachAnnouncementLink: (course_id: string, id: string) => `/trainee/course/${course_id}/announcement/${id}`,
};

export default courseRoutes;